export const ListStoreEnum = {
    GRID : 'grid' ,
    VERTICAL : 'vertical' ,
    NO_PIC : 'no_pic'
}